import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Text from 'components/common/Text'

const SettingsSection = ({
  hasBorder,
  title,
  secondaryText,
  children,
  fill
}) => {
  return (
    <Div
      paddingTop={16}
      paddingBottom={16}
      paddingLeft={12}
      paddingRight={12}
      flex={fill && 1}
      display="flex"
      flexDirection="column"
      borderBottom={hasBorder && '1px solid #dbdce0'}
    >
      {title && (
        <Div
          marginBottom={16}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Text size={18}>{title}</Text>
          {secondaryText && <Text size={18}>{secondaryText}</Text>}
        </Div>
      )}
      {children}
    </Div>
  )
}

SettingsSection.propTypes = {
  hasBorder: PropTypes.bool,
  title: PropTypes.string,
  fill: PropTypes.bool,
  secondaryText: PropTypes.string,
  children: PropTypes.any
}

SettingsSection.defaultProps = {
  fill: false,
  hasBorder: false
}

export default SettingsSection



// WEBPACK FOOTER //
// ./src/components/settings/SettingsSection.js